// 利用者画面リロードまでの時間（ミリ秒）59分
export const autoReloadTime = 59 * 60 * 1000
